import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <CardTitle className="text-6xl font-bold text-brand-primary mb-4">
            404
          </CardTitle>
          <h1 className="text-2xl font-semibold text-gray-900">
            Seite nicht gefunden
          </h1>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600 mb-6">
            Die gesuchte Seite konnte nicht gefunden werden.
          </p>
          <Button asChild>
            <Link to="/">
              Zur Startseite
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
